import { ComponentChild } from 'preact'

import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

export interface LinkBoxItemProps extends SharedProps {
  link: string
  layout?: string
  media?: ComponentChild
  label?: string
  text?: string
}

export function LinkBoxItem({ layout, media, label, link, text, classNames, attributes = {} }: LinkBoxItemProps) {
  const componentClassName = 'ds-link-box-item'

  const classes = formatClassString([componentClassName, layout && `${componentClassName}--${layout}`, classNames])

  return (
    <a href={link} className={classes} {...attributes}>
      {media && <div className={`${componentClassName}__media`}> {media} </div>}
      <div className={`${componentClassName}__content`}>
        {label && <span className={`${componentClassName}__label`}>{label}</span>}
        {text && <span className={`${componentClassName}__text`}>{text}</span>}
      </div>
    </a>
  )
}
